import { combineReducers, type Action } from "@reduxjs/toolkit";
import { resetStore } from "./actions";
import themeReducer from "./slices/themeSlice";
import recipesReducer from "./slices/recipesSlice";
import recentViewsSlice from "./slices/recentViewsSlice";
import collectionsSlice from "./slices/collectionsSlice";
import recipeCollectionsSlice from "./slices/recipeCollections";
import ingredientsSlice from "./slices/ingredientsSlice";
import methodStepsSlice from "./slices/methodStepsSlice";
import cookingProgressSlice from "./slices/cookingProgressSlice";
import cookingHistorySlice from "./slices/cookingHistorySlice";
import searchHistorySlice from "./slices/searchHistorySlice";
import mealPlanSlice from "./slices/mealPlanSlice";
import shoppingListSlice from "./slices/shoppingListSlice";
import shoppingListsSlice from "./slices/shoppingListsSlice";
import syncSlice from "./slices/syncSlice";
import preferencesReducer from "./slices/preferencesSlice";

const combinedReducer = combineReducers({
  recipes: recipesReducer,
  recipeCollections: recipeCollectionsSlice,
  ingredients: ingredientsSlice,
  methodSteps: methodStepsSlice,
  recentViews: recentViewsSlice,
  collections: collectionsSlice,
  cookingProgress: cookingProgressSlice,
  cookingHistory: cookingHistorySlice,
  searchHistory: searchHistorySlice,
  mealPlan: mealPlanSlice,
  shoppingListItems: shoppingListSlice,
  shoppingLists: shoppingListsSlice,
  sync: syncSlice,
  theme: themeReducer,
  preferences: preferencesReducer,
});

// resetStore wipes every slice back to its initial state (user switch). The root
// reducer intercepts it; pair with persistor.purge() to clear storage too.
// Preferences are account-scoped (synced per user), so they reset here like
// everything else and are re-hydrated from the server on the next sync.
export const rootReducer = (
  state: ReturnType<typeof combinedReducer> | undefined,
  action: Action,
): ReturnType<typeof combinedReducer> =>
  combinedReducer(action.type === resetStore.type ? undefined : state, action);

export type RootState = ReturnType<typeof combinedReducer>;
